import React, { useState, useEffect } from "react";
import Pajination from "../../helpingFiles/Pagination/Pajination";
import SideBar from "../../Components/Navbar/Sidebar";
import Head from "../../Components/ontabletop/head";
import { useLocation } from "react-router-dom";
import { ODOLeads, odoleadstatusChange, otherlead } from "../../Components/Apis/apis";
import "./style.css";
import Loader from "../../Components/loader";
import instance from "../../Components/Apis/axios";
import { toast } from "react-toastify";

const Odoleads = () => {
  const locations = useLocation();
  const path = locations.pathname;
  const [loading, setLoading] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [total, setTotal] = useState("");
  const [page, setPage] = useState(1);
  const [postPerpage, setPostPerPage] = useState(10);
  const [query, setQuery] = useState("");
  const [leadstatus, setLeadStatus] = useState([]);

  const fetchPost = async () => {
    setLoading(true);
    const data = await otherlead(path);
    if (data.message === "You are not authorized for this page") {
      alert(data.message);
    } else {
      setFilterData(data);
      setTotal(data.length);
      setLoading(false);
    }
  };
  const statusofLeads = async () => {
    const { data } = await instance.get(`weblead/leadStatus`);
    setLeadStatus(data);
   
  };
  useEffect(() => {
    fetchPost();
    statusofLeads();
  }, []);

  const headers = [
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "phone", label: "Phone" },
    { key: "created", label: "Created" },
    { key: "source", label: "Source" },
    { key: "message", label: "Message" },
    { key: "status", label: "Status" },
  ];

  // Get Current Posts (Pagination)
  const indexOfLastPage = page * postPerpage;
  const indexOfFirstPage = indexOfLastPage - postPerpage;
  const currentPosts = filterData.slice(indexOfFirstPage, indexOfLastPage);

  const formatDate = (dateTimeString) => {
    const options = { 
      day: "2-digit", 
      month: "2-digit", 
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      hour12: true,
      // timeZoneName: "short"
    };
    const formattedDateTime = new Date(dateTimeString).toLocaleString("en-US", options);
    return formattedDateTime;
  };
  
  const changeStatus = async (status, id) => {
    const data = await odoleadstatusChange(status,id,path);
    if(data.message==="Status updated successfully."){
      toast(data.message);
    }else{
      toast(data.message);
    }
    
  };

  return (
    <>
      <div className="containers">
        <div className="container-sidebar">
          <SideBar />
        </div>
        <>
          <div className="container-pages">
            <Head setPostPerPage={setPostPerPage} setQuery={setQuery} />
            {loading ? (
              <Loader />
            ) : (
              <>
                {currentPosts.length == 0 ? (
                  <h2 className="text-secondary">No Leads found</h2>
                ) : (
                  <>
                    {/* making User tabel */}
                    <table className="table table-boarder table-hover table-striped table-sm">
                      <thead className="thead-dark">
                        <tr>
                          {headers.map((row) => {
                            return <th key={row.key}>{row.label}</th>;
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {currentPosts
                          .filter((obj) => {
                            if (query === "") {
                              return obj;
                            } else if (
                              obj.name
                                .toLowerCase()
                                .includes(query.toLowerCase()) ||
                              obj.email
                                .toLowerCase()
                                .includes(query.toLowerCase()) ||
                              obj.phone
                                .toLowerCase()
                                .includes(query.toLowerCase())
                            ) {
                              return obj;
                            }
                          })
                          .map((posts, index) => (
                            <tr key={index}>
                              <td>{posts.name}</td>
                              <td>{posts.email}</td>
                              <td>{posts.phone}</td>
                              <td>{formatDate(posts.date_created)}</td>
                              <td>{posts.source}</td>
                              <td>{posts.message}</td>
                              <td>
                                      <select
                                        className="form-control-select is-info show-btn"
                                        onChange={(e, a) =>
                                          changeStatus(e.target.value, posts.id)
                                        }
                                      >
                                        {leadstatus.map((el) => (
                               <option key={el.id} 
                               value={el.name}
                              selected={el.statusorder === posts.status}>
                                {el.name}
                                 </option>
                                     ))}
                                      </select>
                                    </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    {/* View of pagination */}
                    <Pajination
                      setPostPerPage={setPostPerPage}
                      postPerpage={postPerpage}
                      page={page}
                      setPage={setPage}
                      total={total}
                    />
                  </>
                )}
              </>
            )}
          </div>
        </>
      </div>
    </>
  );
};

export default Odoleads;
